import React from "react";

import Hero from "./components/Hero";
import Header from "./components/Header";
import About from "./components/About";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import OurApp from "./components/OurApp";
import Form from "./components/Form";

const App = () => {
  return (
    <div className="w-full max-w-[1440px] mx-auto bg-orange-quaternary relative">
      <Header />
      <Hero />
      <About />
      <OurApp />
      <Form />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
